/* eslint-disable rover/no-platform-specific-globals-or-imports */
// @flow
import LOCAL_STORAGE_KEYS from '@rover/shared/js/constants/localStorage.constants';

const trackCumulativeLayoutShift = () => {
  try {
    let maxCls = 0;
    let curr = 0;
    let firstTs = Number.NEGATIVE_INFINITY;
    let prevTs = Number.NEGATIVE_INFINITY;

    const observer = new window.PerformanceObserver((entryList) => {
      // eslint-disable-next-line
    for (const entry of entryList.getEntries()) {
        // eslint-disable-next-line no-continue
        if (entry.hadRecentInput) continue;

        if (entry.startTime - firstTs > 5000 || entry.startTime - prevTs > 1000) {
          firstTs = entry.startTime;
          curr = 0;
        }

        prevTs = entry.startTime;
        curr += entry.value;
        maxCls = Math.max(maxCls, curr);
      }
    });

    observer.observe({ type: 'layout-shift', buffered: true });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        if (!observer.takeRecords || !observer.disconnect) return; // Safari and IE11 don't support these features, but it's fine to just not track CLS there
        observer.takeRecords();
        observer.disconnect();

        const htmlEdgeCacheStatus = window.cloudflare?.htmlEdgeCacheStatus || '';
        const cfCountryCode = window.cloudflare?.countryCode || '';
        // $FlowFixMe navigator.connection is a thing in chrome, and this is safe access
        const effectiveType = navigator.connection?.effectiveType || '';

        const clsEvent = {
          event: 'cumulative-layout-shift',
          cumulativeLayoutShift: maxCls || 0,
          originatingClientUriPath: window.location.pathname,
          htmlEdgeCacheStatus,
          cfCountryCode,
          effectiveType,
        };

        window.localStorage.setItem(LOCAL_STORAGE_KEYS.CLS_EVENT, JSON.stringify(clsEvent));
      }
    });
  } catch (e) {
    // Do nothing if the browser doesn't support this API
  }
};

export default trackCumulativeLayoutShift;



// WEBPACK FOOTER //
// ../utilities/trackCumulativeLayoutShift.js